module.exports = __webpack_public_path__ + "static/media/11A.b84cb763.png";